import React from "react";
import { useSelector } from "react-redux";
import "../table.scss";
import { MainTable, TableWrapper } from "../styles";
import { Skeleton } from "@mui/material";
import NoData from "components/nodata";

const SocialMediaAssetsTable = () => {
  const { loading, smAssets } = useSelector((state) => state.aff_assets);

  const renderSmAssetsData = () => {
    return loading ? (
      <>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
        <tr>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
        </tr>
      </>
    ) : (
      smAssets.map((asset) => {
        const { campaignId: id, assetId, campaignName, noOfAsset } = asset;
        return (
          <tr key={id}>
            <td>
              <label class="customContainer">
                <input type="checkbox" />
                <span class="customCheckmark"></span>
              </label>
            </td>
            <td>{campaignName}</td>
            <td>{assetId}</td>
            {/* <td>
                {loadingId === id? (
                  <Skeleton />
                ) : (
                  formatDate(new Date(createdAt), "dd, mm, yyyy")
                )}
              </td> */}
            <td>{noOfAsset}</td>
          </tr>
        );
      })
    );
  };

  const renderSmAssetsHeader = () => {
    let header = ["", "campaign", "asset ID", "number of assets"];
    return header.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  return (
    <>
      {smAssets.length === 0 && !loading ? (
        <NoData />
      ) : (
        <TableWrapper>
          <MainTable>
            <tbody>
              <tr
                style={{
                  width: "100%",
                }}
              >
                {renderSmAssetsHeader()}
              </tr>
              {renderSmAssetsData()}
            </tbody>
          </MainTable>
        </TableWrapper>
      )}
    </>
  );
};

export default SocialMediaAssetsTable;
